import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactIntersectionObserver from '../react-intersection-observer/ReactIntersectionObserver';

/**
 * Postpones children rendering until its placeholder becomes visible
 */
export default class LazyLoad extends Component {
    static propTypes = {
        /** The element whose exposure we want to track. See ReactIntersectionObserver children for details. */
        placeholder: ReactIntersectionObserver.propTypes.children,
        /** Amount of pixels added to the placeholder dimensions when considering its visibility */
        offset: PropTypes.number
    };

    static defaultProps = {
        children: null,
        offset: 0
    }

    constructor(props) {
        super(props);
        this.state = {hasBeenSeen: false};
    }

    onIntersection = ({isIntersecting}) => {
        if (isIntersecting) {
            this.setState({hasBeenSeen: true});
        }
    }

    render() {
        const {placeholder, children, offset} = this.props;

        return this.state.hasBeenSeen ?
            children :
            <ReactIntersectionObserver rootMargin={`${offset}px`} onIntersection={this.onIntersection}>
                {placeholder}
            </ReactIntersectionObserver>;
    }
}
